module.exports = "<ng-transclude></ng-transclude><div class=\"fn-remove\" ng-click=\"$ctrl.remove()\" ng-if=\"!$ctrl.tagDisabled\">&times;</div>";